import { Currency } from '@constants';

const currencyFormatter = (value: number, lang: string, currency: (typeof Currency)[keyof typeof Currency]) => {
  return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(value);
};

export default currencyFormatter;
